// Shared palette + type tokens for the homepage sections, matching the rest of
// the site (teal/ink) so the redesign stays on-brand. Headings use Poppins,
// body uses Kumbh Sans (same as globals.css / the blog + search pages).

export const HOME = {
  teal: '#079ba9',
  tealDeep: '#068c99',
  tealLight: '#e6f5f6',
  ink: '#1a2342', // deep navy, matching the original design's dark blue
  muted: '#62778f',
  border: '#e7eaee',
  bg: '#ffffff',
  bgSoft: '#f7fafb',
  sun: '#f4c95d',
  sunSoft: '#fdf3da',
};

export const FONT_HEADING = "'Poppins', sans-serif";
export const FONT_BODY = "'Kumbh Sans', sans-serif";
